/**
 * Handle search and filter mobile
 */
const sf_results_mobile = document.querySelector(
  '.l-investments__results--mobile > .search-filter-results'
);

function toggle_card_elms() {
  const results = Array.from(sf_results_mobile.children);
  const has_results = !results.some((row) =>
    row.classList.contains('a-notice')
  );

  if (has_results) {
    results.forEach((row) => {
      const btn = row.querySelector('a');
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        if (row.classList.contains('open')) {
          row.classList.remove('open');
        } else {
          results.forEach((r) => {
            r.classList.remove('open');
          });
          setTimeout(() => {
            row.classList.add('open');
          }, 500);
        }
      });
    });
  }
}

if (sf_results_mobile) {
  toggle_card_elms();

  const observer_mobile = new MutationObserver(() => {
    toggle_card_elms();
  });

  observer_mobile.observe(sf_results_mobile, {
    childList: true,
    subtree: true,
  });
}
